<div class="app-indicators" *ngIf="indicators.size > 0">

  <div class="ui-g">
    <div class="ui-g-12 ui-lg-6">
      <h1 class="step-title">{{ pageTitle | translate }}</h1>
      <br>
    </div>
  </div>

  <div class="ui-g" *ngFor="let row of arrayIndicatorRows;let j=index;">

    <div class="ui-g-12 ui-md-1">
      <div class="highlight-box">
        <span class="fa {{ row.icon }}"></span>
      </div>
    </div>

    <div class="ui-g-12 ui-md-3" *ngFor="let indicator of row.indicators;let i=index;">
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{dynamic:true, decimal_value:2, unit_period_prec:'€', decimal_prec_value: 2}" *ngIf="indicator=='TotalRevenueYTD'"></app-infobox>
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{dynamic:true, decimal_value:3, decimal_prec_value:3}" *ngIf="indicator=='TotalVisitsYTD'"></app-infobox>
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{unit_period_prec:'€',decimal_value:2, decimal_prec_value:2}" *ngIf="indicator=='AvgSpentPerVisitYTD'"></app-infobox>

      <app-infobox [pointData]="indicators.get(indicator)" [options]="{dynamic:true, decimal_value:3, decimal_prec_value:3}" *ngIf="indicator=='SoldVolume'"></app-infobox>
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{decimal_value:2, decimal_prec_value:2, unit_period_prec:'%' }" *ngIf="indicator=='PromoValueIncidence'"></app-infobox>
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{decimal_value:2, decimal_prec_value:2, unit_period_prec:'%' }" *ngIf="indicator=='QuotaPLVolumi'"></app-infobox>
      <app-infobox [pointData]="indicators.get(indicator)" [options]="{decimal_value:2, decimal_prec_value:2, unit_period_prec:'%' }" *ngIf="indicator=='LoyaltyIncidence'"></app-infobox>

      <app-infobox [pointData]="indicators.get(indicator)" [options]="{dynamic:true,  decimal_value:3, decimal_prec_value:3, unit_period_prec:'€'}" *ngIf="j==4"></app-infobox>

      <app-infobox [pointData]="indicators.get(indicator)" *ngIf="j!=4 && indicator!='TotalRevenueYTD' && indicator!='AvgSpentPerVisitYTD' && indicator!='TotalVisitsYTD' && indicator!='SoldVolume' && indicator!='PromoValueIncidence' && indicator!='QuotaPLVolumi' && indicator!='LoyaltyIncidence'"></app-infobox>
    </div>

    <div class="ui-g-12 ui-md-2">
      <div class="highlight-box">
      </div>
    </div>
  </div>
  <div class="ui-g ui-g-12 last-update-row" *ngIf="referencePeriod">
    <div class="last-update-container">
      <span class="last-update">{{ 'indicator.reference_period' | translate }}: {{ referencePeriod.data_inizio | date: 'dd/MM/yyyy' }} - {{ referencePeriod.data_fine | date: 'dd/MM/yyyy' }}</span>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/views/indicators/indicators.component.html